import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import"../componnetsCss/Deposit.css"
import Carousel from "react-bootstrap/Carousel";
import { Link, useLocation } from "react-router-dom";
import firstImg from "../images/asda.jpg";
import { getDatabase, onValue, ref } from "firebase/database";
import { app } from "../Firebase";
import a from "../PayImages/113.png";
import b from "../PayImages/easypaisa.png";
import {
  FaHatWizard,
  FaWhatsapp,
  FaPhone,
  FaPhoneAlt,
  FaPiggyBank,
  FaMehBlank,
  FaUniversity,
  FaCloudDownloadAlt,
  FaCloudUploadAlt,
} from "react-icons/fa";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";

const Deposit = () => {
  // const[Bal , setBal ] = useState()
  // const[name , setName] = useState()

  const location = useLocation().state.value;
  const locations = useLocation().state.userid;
  console.log(locations);
  const locationa = useLocation().state.showUserName;
  const userName = locationa;
  const balance = location;
  //   setName(userName)
  //   setBal(balance)
  //   console.log(balance);

  return (
    <div className="deposit-page-wrapper">
  {/* Modern Custom Carousel */}
  

  <div className="deposit-content-container">
    {/* Welcome Header */}
    <div className="user-welcome-section">
      <h3 className="greeting-text">Assalam o Alaikum,</h3>
      <h2 className="user-identity">{userName}</h2>
    </div>

    {/* Balance Card */}
    <div className="balance-display-card">
      <span className="label">Current Balance</span>
      <div className="amount-val">Rs. {balance}</div>
    </div>

    {/* Payment Bank Details Card */}
 
    <div className="payment-method-card">
      <div className="card-header-premium">
        <FaUniversity /> Easypaisa
      </div>
      <div className="bank-card-body">
        <div className="bank-logo-area">
          <img src={b} alt="Bank Logo" className="bank-img-rounded" />
        </div>
        <div className="bank-info">
          <p className="info-item"><span>Name:</span> <strong>Muhammad Hasnan</strong></p>
          <p className="info-item"><span>Number:</span> <strong>03276053216</strong></p>
        </div>
      </div>
    </div>

    {/* Deposit Form */}
    <form 
      action="https://usebasin.com/f/f93922dac2d7" 
      method="POST" 
      encType="multipart/form-data"
      className="deposit-form"
    >
      <div className="form-title-group">
        <h3>Submit Deposit Proof</h3>
        <p>Enter details after sending payment</p>
      </div>

      <div className="custom-input-group">
        <label>Sender Account Number</label>
        <input 
          type="text" 
          name="Number" 
          placeholder="03xx xxxxxxx" 
          required 
        />
      </div>

      <div className="custom-input-group">
        <label>Sender Name</label>
        <input 
          type="text" 
          name="Name" 
          placeholder="Enter full name" 
          required 
        />
      </div>

      <div className="custom-input-group">
        <label>Payment Screenshot</label>
        <div className="file-upload-wrapper">
          <input 
            type="file" 
            name="resume[]" 
            required 
            id="file-upload"
          />
          <label htmlFor="file-upload" className="file-label">
            <FaCloudUploadAlt /> Choose Image
          </label>
        </div>
      </div>

      {/* Hidden/Read-only UID field styled cleanly */}
      <div className="uid-display">
        <label>User ID / Location Reference</label>
        <input 
          type="text" 
          value={locations} 
          name="uid" 
          readOnly 
        />
      </div>

      <button type="submit" className="submit-deposit-btn">
        Submit Payment Proof
      </button>
    </form>
  </div>
</div>
  );
};

export default Deposit;
